import { createRoute } from "./createRouter";

const routes = [createRoute("/auth", "", () => import("@/common/Auth.vue")), createRoute("/logout", "", () => import("@/components/auth/LogOut.vue"))];

export default routes;
